// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__25Z2U","ranges":"BmiRanges_ranges__3UW_h"};